import { Card, Stack } from '@etg/wings';
import { useHistory } from 'react-router-dom';
import { useProperty, useTranslation } from '@eti/providers';
import type { Dispatch, SetStateAction } from 'react';
import { css } from '@eti/styles';
import Header from '../../../widgets/customer-support/Header';
import LoginMessage from '../containers/LoginMessage';
import LoginFormContainer from '../containers/LoginFormContainer';
import { SourceOfLogin } from '../containers/models';
import SocialMediaLoginContainer from '../containers/SocialMediaLoginContainer';
import { routes } from '../../../constants/routesAndApisConstants';
import { cardStyles, flexContentWrapperStyles } from './styles';

const formStyles = css`
  margin-top: 24px;
`;

interface LoginProps {
  notification: { message: string; type: string; dataTestId: string } | null;
  setNotification: Dispatch<
    SetStateAction<{ message: string; type: string; dataTestId: string } | null>
  >;
}

const Login = ({ notification, setNotification }: LoginProps) => {
  const history = useHistory();
  const { p } = useProperty();
  const { t } = useTranslation();

  const shouldShowFacebookButton = p('IbeClient.MyBookings.Facebook.Button.Enabled');
  const shouldShowGoogleButton = p('IbeClient.MyBookings.Google.Button.Enabled');
  const isOrderLoginPage = history.location.pathname === routes.ORDER_AUTHENTICATION;
  const headerTitle = isOrderLoginPage
    ? t('Postbooking.Login.Header.Title')
    : t('Postbooking.Ancillary.Login.Header.Title');
  const headerSubtitle = isOrderLoginPage
    ? t('Postbooking.Login.Header.Subtitle')
    : t('Postbooking.Ancillary.Login.Header.Subtitle');

  const shouldShowSocialMediaLoginContainer =
    (shouldShowGoogleButton || shouldShowFacebookButton) && isOrderLoginPage;

  return (
    <>
      <Header
        data-testid="postbooking-login-header"
        subtitle={headerSubtitle}
        title={headerTitle}
      />
      <div className={flexContentWrapperStyles}>
        <Stack spacing={32}>
          <Card className={cardStyles} data-testid="order-page">
            <Stack>
              {notification?.message && notification?.type && (
                <LoginMessage notification={notification} />
              )}
            </Stack>
            <Stack className={formStyles} spacing={8}>
              <LoginFormContainer
                setNotification={setNotification}
                source={isOrderLoginPage ? SourceOfLogin.ORDER : SourceOfLogin.POSTBOOKING}
              />
              {shouldShowSocialMediaLoginContainer && (
                <SocialMediaLoginContainer
                  setNotification={setNotification}
                  shouldShowFacebookButton={shouldShowFacebookButton}
                  shouldShowGoogleButton={shouldShowGoogleButton}
                />
              )}
            </Stack>
          </Card>
        </Stack>
      </div>
    </>
  );
};

export default Login;
